import { RecordUtils } from "@rsm-hcd/javascript-core";
import { NotebookPageContentBlock } from "constants/notebooks/notebook-page-content-blocks";
import { Record } from "immutable";
import {
    ChecklistBlock,
    ChecklistItemInput,
    PopulatedBlock,
} from "models/interfaces/populated-blocks/populated-block";

// region Checklist Item Input

const checklistItemInputDefaults: ChecklistItemInput = {
    text: "",
    note: undefined,
};

export class ChecklistItemInputRecord
    extends Record(checklistItemInputDefaults)
    implements ChecklistItemInput
{
    constructor(params?: Partial<ChecklistItemInput>) {
        if (params == null) {
            params = Object.assign({}, checklistItemInputDefaults);
        }

        super(params);
    }

    public with(values: Partial<ChecklistItemInput>): ChecklistItemInputRecord {
        return new ChecklistItemInputRecord(Object.assign(this.toJS(), values));
    }
}

// endregion

// region Checklist Block

const checklistBlockDefaults: ChecklistBlock = {
    type: NotebookPageContentBlock.Checklist,
    isNumbered: false,
    usesCustomStatuses: false,
    items: [],
};

export class ChecklistBlockRecord
    extends Record(checklistBlockDefaults)
    implements ChecklistBlock
{
    constructor(params?: Partial<ChecklistBlock>) {
        // To handle assigning items value if it is already a Record
        const plainParams = Record.isRecord(params)
            ? (params.toObject() as Partial<ChecklistBlock>)
            : params;
        const values = Object.assign({}, checklistBlockDefaults, plainParams);

        values.items = RecordUtils.ensureRecords(
            values.items ?? [],
            ChecklistItemInputRecord
        );

        super(values);
    }

    public with(values: Partial<ChecklistBlock>): ChecklistBlockRecord {
        return new ChecklistBlockRecord(Object.assign(this.toJS(), values));
    }
}

// endregion

export type PopulatedBlockRecord = ChecklistBlockRecord;

export const PopulatedBlockRecordFactory = (
    block: PopulatedBlock
): PopulatedBlockRecord => {
    switch (block.type) {
        case NotebookPageContentBlock.Checklist:
            return new ChecklistBlockRecord(block);
    }
};
